// src/auth0-provider-with-history.js

import React from 'react';
import { Auth0Provider } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import { auth0Config, routes } from './config/auth.config';

/**
 * Auth0 Provider wrapper with router integration
 * Manages authentication state and redirects for the entire app
 */
const Auth0ProviderWithHistory = ({ children }) => {
  const navigate = useNavigate();

  const onRedirectCallback = (appState) => {
    // Navigate to the returnTo path or dashboard after login
    navigate(appState?.returnTo || routes.dashboard);
  };

  if (!auth0Config.domain || !auth0Config.clientId) {
    console.error('Auth0 configuration is missing. Please check your environment variables.');
    return (
      <div style={{ padding: '20px', color: 'red' }}>
        <h1>Configuration Error</h1>
        <p>Auth0 is not properly configured. Please contact support.</p>
      </div>
    );
  }

  return (
    <Auth0Provider
      domain={auth0Config.domain}
      clientId={auth0Config.clientId}
      authorizationParams={{
        redirect_uri: auth0Config.redirectUri,
        audience: auth0Config.audience,
        scope: auth0Config.scope,
      }}
      useRefreshTokens={auth0Config.useRefreshTokens}
      cacheLocation={auth0Config.cacheLocation}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWithHistory;
